import React from "react";

const ModelViewPopullata = ({ tableContent }) => {
  const formatNumber = (number) =>
    new Intl.NumberFormat("sq-AL").format(Number(number));

  const styles = {
    container: {
      padding: "32px",
      fontFamily: "Helvetica, Arial, sans-serif",
      fontSize: "13px",
      color: "#000",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginBottom: "48px",
    },
    th: {
      backgroundColor: "#e41e26",
      color: "#fff",
      padding: "6px 8px",
      fontWeight: 500,
      fontSize: "13px",
      borderBottom: "1px solid #000",
      textAlign: "left",
    },
    td: {
      padding: "6px 8px",
      fontSize: "13px",
      borderBottom: "1px solid #ddd",
      verticalAlign: "top",
    },
    alignRight: {
      textAlign: "right",
    },
    totalRow: {
      // vetëm border top tek qelizat që kanë background
    },
    totalLabelCell: {
      textAlign: "right",
      padding: "6px 8px",
      fontWeight: "bold",
      backgroundColor: "#f6d7da", // rozë
      borderTop: "2px solid #e41e26",
    },
    totalValueCell: {
      textAlign: "right",
      padding: "6px 8px",
      color: "#e41e26",
      fontWeight: "bold",
      backgroundColor: "#f6d7da", // rozë
      borderTop: "2px solid #e41e26",
    },
    footerTable: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "48px",
    },
    footerRow: {
      backgroundColor: "#e41e26",
    },
    footerCellLabel: {
      padding: "12px 16px",
      fontWeight: "bold",
      color: "#fff",
      textAlign: "right",
      fontSize: "15px",
    },
    footerCellValue: {
      padding: "12px 16px",
      fontWeight: "bold",
      color: "#fff",
      textAlign: "right",
      fontSize: "15px",
    },
  };

  const grandTotal = Object.values(tableContent).reduce((acc, entries) => {
    return (
      acc + entries.reduce((sum, item) => sum + Number(item.Popullsia || 0), 0)
    );
  }, 0);

  return (
    <div style={styles.container}>
      {Object.entries(tableContent).map(([qarku, entries], index) => {
        const totalPopullsia = entries.reduce(
          (sum, item) => sum + Number(item.Popullsia || 0),
          0
        );

        return (
          <table key={index} style={styles.table}>
            {index === 0 && (
              <thead>
                <tr>
                  <th style={styles.th}>Qarku</th>
                  <th style={styles.th}>Bashkia</th>
                  <th style={styles.th}>Njësia Administrative</th>
                  <th style={{ ...styles.th, ...styles.alignRight }}>
                    Popullsia
                  </th>
                </tr>
              </thead>
            )}
            <tbody>
              {entries.map((entry, idx) => (
                <tr key={idx}>
                  <td style={styles.td}>{entry.Qarku}</td>
                  <td style={styles.td}>{entry.Bashkia}</td>
                  <td style={styles.td}>{entry["Njësia Administrative "]}</td>
                  <td style={{ ...styles.td, ...styles.alignRight }}>
                    {formatNumber(entry.Popullsia)}
                  </td>
                </tr>
              ))}
              <tr style={styles.totalRow}>
                <td colSpan={2} style={{ borderTop: "2px solid #e41e26" }}></td>
                <td style={styles.totalLabelCell}>Totali për {qarku}</td>
                <td style={styles.totalValueCell}>
                  {formatNumber(totalPopullsia)}
                </td>
              </tr>
            </tbody>
          </table>
        );
      })}

      <table style={styles.footerTable}>
        <tbody>
          <tr style={styles.footerRow}>
            <td colSpan={3} style={styles.footerCellLabel}>
              Totali i përgjithshëm i popullsisë:
            </td>
            <td style={styles.footerCellValue}>{formatNumber(grandTotal)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ModelViewPopullata;
